<template>
    <div>
        该模块暂未开通
        <!--<Tabs value="name1">
            <TabPane label="标签一" name="name1">标签一的内容</TabPane>
            <TabPane label="标签二" name="name2">标签二的内容</TabPane>
        </Tabs>-->
    </div>
</template>
<script>
    export default {
        components: {},
        data () {
            return {
                cid:"",


            }
        },

        mounted: function() {
            //DOM更新完后再请求数据
            this.$nextTick(function() {

            });
        },
        created: function() {
            //DOM更新完之前请求数据
            let data= JSON.parse(localStorage.getItem('adminUser'))
            this.cid=data.cid


        },
        methods: {
            getConpanyMsg(id){
                let data = {
                    id:id
                };
                this.$Api.getCompanyId(data).then(res => {
                    if(res.code==200){


                    }else {
                        this.$Message.warning(res.msg);
                    }
                });
            },


        }
    }
</script>


<style  lang="scss" scoped>
    .server-title{
        display: inline-block;
        text-align: center;width: 88%
    }
    .logo{
        width: 50px;
        height: 50px;
        margin: auto;
    }
.ivu-form-item{
    height: 30px;
}
</style>